/**
 *
 * Asynchronously loads the component for ConfirmOrder
 *
 */

import ReactLoadable from 'react-loadable'

export default ReactLoadable({
  loader: () => import('./index'),
  loading: () => null
})
